__turbopack_context__.v({
  "enrollment-count": "enrollment-count-module-scss-module__3KI-AG__enrollment-count",
  "student-count": "enrollment-count-module-scss-module__3KI-AG__student-count",
});
